import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Dropdown from "@shared/v2/Dropdown";

const LastWebsiteVisitSelect = ({ options, previousSelected }) => {
  const [selected, setSelected] = useState(options.find((o) => o.value === previousSelected) || null);

  // Clear All wipes the DOM inputs via jQuery, which can't reach this react-select's
  // state — so reset it here too, otherwise the selection sticks after Clear All.
  useEffect(() => {
    const clearButton = document.querySelector("#clear-all-modal-filters");
    const clear = () => setSelected(null);
    clearButton?.addEventListener("click", clear);
    return () => clearButton?.removeEventListener("click", clear);
  }, []);

  return (
    <div id="filter-last_website_visit" className="tw-flex-1">
      <Dropdown
        label="Last Website Visit"
        id="last_website_visit_filter"
        name="leads_filter[selected_last_website_visit_filters][]"
        options={options}
        placeholder="Select..."
        value={selected}
        onChange={setSelected}
        isClearable
        menuShouldComeToFront
      />
    </div>
  );
};

LastWebsiteVisitSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  previousSelected: PropTypes.string,
};

LastWebsiteVisitSelect.defaultProps = {
  previousSelected: null,
};

export default LastWebsiteVisitSelect;
